<template>
    <vProjectPreview v-if="notDeletedFiles.length" :views="views" v-model="chosenView">
        <vPreviewIframe
            v-if="isPlayerView"
            :back="player.transparentBackground ? '' : player.playerColor"
            :src="`/preview/players/${player.uuid}`"
        />
        <vPreviewIframe
            v-if="isCertificateView"
            :back="player.transparentBackground ? '' : player.playerColor"
            :src="`/preview/players/${player.uuid}/certificates/1`"
        />
        <vPreviewIframe
            v-if="isBadgeView"
            :back="player.transparentBackground ? '' : player.playerColor"
            :src="`/preview/players/${player.uuid}/badges/1`"
        />
    </vProjectPreview>
    <CardEmpty
        class="w-full ct-bg-1"
        v-else
        :title="$t('player.empty.title')"
        :icon="emptyIcon"
        :ctaLabel="$t('player.empty.cta')"
        lightBackground
        @add="createFile"
    />
</template>

<script>
import { markRaw } from "vue";
import { PLAYER_PREVIEW_KIND, PLAYER_ROUTE_NAMES } from "@/apps/player/player.routes";
import { mapActions, mapMutations, mapState } from "vuex";
import { MultipleFileIcon, PageIcon, PlayerIcon, TrophyIcon } from "@easy/ui/icons";
import { CardEmpty } from "@easy/ui/cards";
import vPreviewIframe from "@/shared/views/vPreviewIframe.vue";
import vProjectPreview from "@/shared/views/vProjectPreview.vue";

export default {
    name: "PlayerProjectPreview",
    components: {
        vPreviewIframe,
        vProjectPreview,
        CardEmpty,
    },
    mounted() {
        this.$watch(
            () => [
                this.player,
                this.files,
                this.headers,
                this.size,
                this.chosenView,
                this.lang,
                this.certificate,
            ],
            () => this.refreshIframe(),
            {
                immediate: true,
                deep: true,
            }
        );
        this.$watch(
            () => this.chosenView,
            () => this.setIframeLoaded(false)
        );

        this.$watch(
            () => this.$route.query.file,
            (fileId) =>
                this.sendIframeChildMessage({
                    action: "changeSelectedFile",
                    payload: { fileId: Number(fileId || 0) },
                }),
            { immediate: true }
        );
    },
    data() {
        return {
            chosenView: PLAYER_PREVIEW_KIND.player,
        };
    },
    computed: {
        ...mapState(["lang"]),
        ...mapState("player", ["player", "files", "headers", "certificate"]),
        emptyIcon() {
            return markRaw(MultipleFileIcon);
        },
        views() {
            return [
                {
                    label: this.$t("player.views.player"),
                    value: PLAYER_PREVIEW_KIND.player,
                    icon: PlayerIcon,
                },
                {
                    label: this.$t("player.views.certificate"),
                    value: PLAYER_PREVIEW_KIND.certificate,
                    icon: PageIcon,
                },
                {
                    label: this.$t("player.views.badge"),
                    value: PLAYER_PREVIEW_KIND.badge,
                    icon: TrophyIcon,
                },
            ];
        },
        fontFamilyStyle() {
            return { "font-family": this.player.fontFamily };
        },
        notDeletedFiles() {
            return this.files.filter((file) => !file._deleted);
        },
        isPlayerView() {
            return this.chosenView === PLAYER_PREVIEW_KIND.player;
        },
        isCertificateView() {
            return this.chosenView === PLAYER_PREVIEW_KIND.certificate;
        },
        isBadgeView() {
            return this.chosenView === PLAYER_PREVIEW_KIND.badge;
        },
    },
    methods: {
        ...mapMutations("player", ["setIframeLoaded"]),
        ...mapActions("player", ["refreshIframe", "sendIframeChildMessage"]),
        createFile() {
            this.routeTo(PLAYER_ROUTE_NAMES.projectFiles, "create");
        },
        routeTo(name, open) {
            const { query } = this.$route;
            this.$router.push({ name, query: { ...query, open } });
        },
    },
};
</script>
